import type { IMediaType } from '~/entities/content/media/interfaces/media-type'

import type { Acl, DerivedTypeAcl } from '~/features-shared/libs/interfaces/authorization'
import type { SUBJECT_6W_URI } from '~/features-shared/libs/interfaces/entity'

/** Derived media type */
export enum MediaDerivedType {
  Whiteboard = 'WHITEBOARD',
  Story = 'STORY',
}

export enum EDerivedTypeParent {
  POST = 'POST',
  IDEA = 'IDEATION',
  MEDIA = 'MEDIA',
}

export type EDefaultTypeParent = 'COMMUNITY'

export interface IDerivedTypeResponse {
  label: string
  parent: EDerivedTypeParent
  icon: string
  color: string
  id: string
  acl: DerivedTypeAcl
  media_type: MediaDerivedType
}

export interface IDerivedTypeData {
  label: string
  parent: EDerivedTypeParent
  icon: string
  color: string
  id: string
  _acl: Acl
  media_type: MediaDerivedType
}

export interface IMemberDerivedTypeData {
  count: number
  derived_type_id: string
  label: string
}

export interface IDerivedTypeMedia {
  width: number
  height: number
  id: string
  /**
   * The media type. (picture, document, video, etc...)
   */
  media_type: IMediaType
  fingerprint: string
  extension: string
  subject6wuri: SUBJECT_6W_URI
  acl: Acl
  processing_version: number
  processing_state: string
}

/**
 * Derived Type Params for 3DStory
 * Inject to player config
 */
export interface IDerivedTypeParams {
  /**
   * Derived type id
   * @type {string}
   */
  derivedTypeId: string

  /**
   * Template Id
   * @type {string}
   */
  templateId?: string
}
